<template>
  <div class="container bottom-fix-padding">
    <div class="top-bg">
      <div class="navi">
          <a @click="$router.go(-1)">
            <span class="icon-arrow-left"></span>
          </a>
      </div>
      <div class="title">信用卡付款</div>
    </div>
    <div class="weui-cells__title">信用卡支付</div>
    <div class="weui-cells weui-cells_form main" >
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">卡号</label>
            </div>
            <div class="weui-cell__bd" :class="{'color-red':cardType=='none'}">
                <input class="weui-input" id="cardid" type="tel" pattern="[0-9]*" maxlength="16" placeholder="请输入信用卡号" autocomplete="cc-number" v-model="cc.digit" />
            </div>
            <div class="weui-cell__ft">
              <img class="cc-all" v-show="cardType=='all'" src="../../assets/img/order/cc.svg">
              <img class="cc-visa" v-show="cardType=='visa'" src="../../assets/img/order/visa.svg">
              <img class="cc-master" v-show="cardType=='mastercard'" src="../../assets/img/order/master.svg">
              <span v-show="cardType=='none'" class="icon-error color-red"></span>
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">有效期</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" id="validMM" autocomplete="cc-exp-month" v-model="cc.validmm" type="tel" pattern="[0-9]*" maxlength="2" placeholder="MM" style="display:inline-block;width:30px;" max="12" :class="{'color-red':cc.validmm>12}"/>
                <span> / </span>
                <input class="weui-input" id="validYY" autocomplete="cc-exp-year"  v-model="cc.validyy" type="tel" pattern="[0-9]*" maxlength="4" placeholder="YYYY" style="display:inline-block;width:50px;margin-left:8px;" :class="{'color-red': cc.validyy<new Date().getFullYear() && cc.validyy.toString().length==4} "/>
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label" autocomplete="cc-cvv">安全码</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" id="cvv" type="tel" v-model="cc.cvv" pattern="[0-9]*" maxlength="3" placeholder="请输入3位安全码" />
            </div>
            <div class="weui-cell__ft">
              <span class="icon-help-circle" @click="cvvShow=true"></span>
            </div>
        </div>
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">名字</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" id="ccName" type="text" placeholder="请输入持卡人姓名" v-model="cc.name" autocomplete="cc-name"/>
            </div>
        </div>
        <label class="weui-cell weui-check__label" for="s15">
            <div class="weui-cell__hd">
                <img class="ssl" src="../../assets/img/order/ssl.svg">
            </div>
            <div class="weui-cell__bd">
                <p class="valign ssl-text">本站数据传输使用 SSL（安全套接字层）技术进行编码，保证支付数据与个人隐私安全</p>
            </div>
        </label>
    </div>
    <div class="cvv-tutorial" v-show="cvvShow">
      <img src="../../assets/img/order/cvv.png">
      <div class="cvv-text">信用卡背面数字的最后3位，即为安全码<br>本站支持 Visa 和 MasterCard </div>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn active" @click="pay()">立即支付 {{$route.query.amount | numeral('$0,0.00')}}</div>
      </div>
    </div>

    <div style="display:none">
      <form name="payFormCcard" id="ccform" method="post" action="https://www.paydollar.com/b2c2/eng/dPayment/payComp.jsp">
      <!-- <form name="payFormCcard" id="ccform" method="post" action="https://test.paydollar.com/b2cDemo/eng/dPayment/payComp.jsp"> -->
        <tr>
          <td align="center" colspan="2">Required Parameter ( with UTF-8 Encoding ) for connect to our payment page</td>
        </tr>
        <tr>
          <td align="right">merchantId:</td>
          <td align="left"><input type="text" name="merchantId" v-model="form.merchantId"> </td>
        </tr>
        <tr>
          <td align="right">amount:</td>
          <td align="left"><input type="text" name="amount" v-model="form.amount"> </td>
        </tr>
        <tr>
          <td align="right">orderRef:</td>
          <td align="left"><input type="text" name="orderRef" v-model="form.orderRef" > </td>
        </tr>
        <tr>
          <td align="right">currCode:</td>
          <td align="left"><input type="text" name="currCode" v-model="form.currCode" > </td>
        </tr>
        <tr>
          <td align="right">successUrl:</td>
          <td align="left"><input type="text" name="successUrl" v-model="successUrl"> </td>
        </tr>
        <tr>
          <td align="right">failUrl:</td>
          <td align="left"><input type="text" name="failUrl" v-model="failUrl"> </td>
        </tr>
        <tr>
          <td align="right">errorUrl:</td>
          <td align="left"><input type="text" name="errorUrl" v-model="errorUrl"> </td>
        </tr>
        <tr>
          <td align="right">payType:</td>
          <td align="left"><input type="text" name="payType"  v-model="form.payType" > </td>
        </tr>
        <tr>
          <td align="right">lang:</td>
          <td align="left"><input type="text" name="lang" v-model="form.lang"> </td>
        </tr>

        <tr>
          <td align="right">Card Type</td>
          <td>
            <input type="radio" name="pMethod" value="VISA" :checked="isVisa()">VISA
            <input type="radio" name="pMethod" value="Master" :checked="isMaster()">MasterCard
          </td>
        </tr>
        <tr>
          <td align="right"> Card Number </td>
          <td align="left"><input name="cardNo" type="text" v-model="cc.digit" maxlength="16"></td>
        </tr>
        <tr>
          <td align="right"> Card Verification Number </td>
          <td align="left"><input name="securityCode" type="text" v-model="cc.cvv" value="" maxlength="4"></td>
        </tr>
        <tr>
          <td align="right"> Expiry Date</td>
          <td align="left">
            <select name="epMonth" v-model="cc.validmm">
              <option value="">--</option>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            /
            <select name="epYear">
              <option v-model="cc.validyy" selected>{{cc.validyy}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td align="right"> Holder Name </td>
          <td align="left"><input name="cardHolder" type="text" v-model="cc.name"></td>
        </tr>

        <tr>
          <td align="center" colspan="2">Optional Parameter for connect to our payment page</td>
        </tr>
        <tr>
          <td align="right">secureHash:</td>
          <td align="left"><input type="text" name="secureHash" v-model="form.secureHash" > </td>
        </tr>
        <tr>
          <td align="right">remark:</td>
          <td align="left"><input type="text" name="remark" v-model="form.remark"> </td>
        </tr>

      </form>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div id="loadingToast" v-show="isSending">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">正在支付中</p>
        </div>
    </div>
  </div>
</template>

<script>
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';
import qs from 'qs'

export default {
  name: 'HelloWorld',
  data () {
    return {
      isSending:false,
      cvvShow:false,
      localError:[],
      localErrorShow:false,
      cc:{
        'name':'',
        'digit':'',
        'validmm':'',
        'validyy':'',
        'cvv':'',
      },
      form:{
        merchantId:"",
        orderRef:"",
        currCode:"",
        amount: "",
        payType: "",
        lang: "",
        remark: "",
        order_number: "",
        pay_status: "",
        secureHash: ""
      }
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    isVisa(){
      if(this.cardType=="visa"){
        return true;
      }
      else{
        return false;
      }
    },
    isMaster(){
      if(this.cardType=="mastercard"){
        return true;
      }
      else{
        return false;
      }
    },
    checkSubmit(){
      if(this.cc.validyy.toString().length==2){
        this.cc.validyy = "20"+this.cc.validyy;
        this.cc.validyy = parseInt(this.cc.validyy);
      }
      this.localError = [];
      if (!this.cc.digit) {
        this.localError.push("请填写信用卡号码");
      } else if (this.cc.digit.length!=16) {
        this.localError.push("请填写16位信用卡号码");
      }
      if(this.cardType=='none'){
        this.localError.push("抱歉，目前仅支持 Visa 或 MasterCard 信用卡");
      }
      if (!this.cc.validmm) {
        this.localError.push("请填写信用卡有效期月份");
      }
      if (this.cc.validmm>12) {
        this.localError.push("有效期月份必须为01-12");
      }
      if (!this.cc.validyy) {
        this.localError.push("请填写信用卡有效期年份");
      }
      if (this.cc.validyy.toString().length!=4) {
        this.localError.push(this.cc.validyy.toString().length);
      }
      if (this.cc.validyy<new Date().getFullYear()) {
        this.localError.push("请检查信用卡有效年份，确认是否过期");
      }
      if (!this.cc.cvv) {
        this.localError.push("请填写3位信用卡安全码");
      } else if (this.cc.cvv.length!=3) {
        this.localError.push("请填写3位信用卡安全码");
      }
      if (!this.cc.name) {
        this.localError.push("请填写持卡人名称");
      }
      if (!this.localError.length) {
        return true;
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    pay(){
      if(this.isSending){
        return false;
      }
      else{
        if(this.checkSubmit()){
          if(this.cc.validmm.toString().length==1){
            this.cc.validmm = "0"+this.cc.validmm;
          }
          let payObject={};
          let that = this;
          this.isSending = true;
          payObject.pay_type = 4;
          payObject.order_number = this.$route.query.id;
          this.axios.post(this.apiURL()+'/Payment_Order/paymentAmount', qs.stringify(payObject))
          .then(function (response) {
            if(response.data.error_code==0){
              that.form = response.data.data;
              that.sleep(500).then(() => {
                document.querySelector("#ccform").submit();
              });
            }
            else{
              console.log(response)
              alert("支付失败："+response.data.data)
              that.isSending=false;
            }
          })
          .catch(function (error) {
              alert("支付失败，请检查网络并重新尝试")
              that.isSending=false;
          });
        }
      }
    },
  },
  computed:{
    cardType: function () {
      let result = "";
      if(this.cc.digit.toString().length<4){
        result = "all";
      }
      else{
        let card = creditCardType(this.cc.digit);
        if(card.length>0){
          result = card[0].type;
        }
        else{
          result = "none";
        }
      }
      if(result!="mastercard" && result!="visa" && result!="all"){
        result = "none";
      }
      return result;
    },
    successUrl: function () {
      let url = this.theURL()+"/order-success?id="+this.$route.query.id+"&pay_status="+this.form.pay_status;
      return url;
    },
    failUrl: function () {
      let url = this.theURL()+"/order-error-cc?id="+this.$route.query.id;
      return url;
    },
    errorUrl: function () {
      let url = this.theURL()+"/order-error-cc?id="+this.$route.query.id;
      return url;
    },
  },
  watch: {
    'cc.validmm': function (val) {
      if(val.toString().length==2 && this.cc.validyy==""){
        document.querySelector("#validYY").focus();
      }
    },
    'cc.validyy': function (val) {
      if(val.toString().length==4 && this.cc.cvv==""){
        document.querySelector("#cvv").focus();
      }
    },
    'cc.digit': function (val) {
      if(val.toString().length==16 && this.cc.validmm==""){
        document.querySelector("#validMM").focus();
      }
    },
    'cc.cvv': function (val) {
      if(val.toString().length==3 && this.cc.name==""){
        document.querySelector("#ccName").focus();
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navi{
  color:#fff;
}
.top-bg{
  background-image: url('/static/img/order/payment-bg.svg');
  background-repeat: no-repeat;
  width:100%;
  height:120px;
  background-position: center center;
  background-size: cover;
  position:absolute;
  top:0;
  padding-top:15px;
}
.container{
  background-color: #f8f8f8;
  padding-bottom:60px;
}
.weui-cells__title{
    font-size: 22pt;
    text-align: center;
    padding: 0 0 2vh 0;
    font-weight: bold;
}
.title{
  color:#fff;
}

.addr-title{
    font-size:0.6em;
    line-height:2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

.deleteWP{
    padding:18px;
}

.parking-icon{
    color:#fe9567;
    line-height:1.5;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.padding-fix{
    padding-right:13px;
}

.placeholder-color{
    color:#777;
}
.cvv-tutorial{
  margin-top:14px;
  text-align:center;
  img{
    width:60%;
  }
  .cvv-text{
    font-size:0.9em;
  }
}
.cc-visa{
  height:14px;
}
.cc-master{
  height:24px;
}
.cc-all{
  height:24px;
}
.icon-error{
  font-size:18px;
}
.icon-help-circle{
  font-size:18px;
}
.main{
  margin-top:50px;
}
.ssl{
  width:60px;
  margin:0 10px;
}

.cc-line{
  color:#999;
}

.valign{
  display: flex;
	justify-content:space-between;
	align-items:center
}
.ssl-text{
  font-size:0.7em;
  color:#888;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-cc.vue